import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
import { Radio as i, RadioGroup as a } from "@base-ui/react";
//#region src/radio/primitive/index.tsx
var o = r("transition-base border-control-border flex size-5 shrink-0 items-center justify-center rounded-full border-2 bg-transparent transition-[background-color,border-color,box-shadow] outline-none", { variants: {
	checked: { true: "border-control-active bg-control-active" },
	interactive: { true: [
		"hover:border-control-border-hover",
		"data-checked:border-control-active data-checked:bg-control-active",
		"data-checked:hover:border-control-active-hover data-checked:hover:bg-control-active-hover",
		"data-disabled:border-control-border-disabled data-disabled:cursor-not-allowed",
		"data-checked:data-disabled:border-control-active-disabled data-checked:data-disabled:bg-control-active-disabled",
		"data-checked:data-disabled:hover:border-control-active-disabled data-checked:data-disabled:hover:bg-control-active-disabled",
		"focus-visible:focus-ring-primary"
	] }
} }), s = r("transition-base bg-icon-on block size-[6.667px] rounded-full transition-[opacity,transform]", { variants: { interactive: { true: ["data-starting-style:scale-0 data-starting-style:opacity-0", "data-ending-style:scale-0 data-ending-style:opacity-0"] } } }), c = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(a, {
	ref: i,
	className: e("grid gap-5", t),
	...r
})), l = t(({ className: t, ...r }, a) => /* @__PURE__ */ n(i.Root, {
	ref: a,
	className: e(o({ interactive: !0 }), t),
	...r
})), u = t(({ className: t, ...r }, a) => /* @__PURE__ */ n(i.Indicator, {
	ref: a,
	className: e(s({ interactive: !0 }), t),
	...r
}));
c.displayName = "Radio.Group", l.displayName = "Radio.Root", u.displayName = i.Indicator.displayName;
var d = {
	Group: c,
	Root: l,
	Indicator: u
};
//#endregion
export { d as Radio, s as radioIndicatorVariants, o as radioRootVariants };
